// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const enrollmentReport = (state) =>
  get(state, ['reports', 'enrollmentReport'], {})

export const enrollmentReportList$ = createSelector(
  enrollmentReport,
  ({ enrollmentReportList = [] }) => enrollmentReportList
)

export const enrollmentPredefinedFilter$ = createSelector(
  enrollmentReport,
  ({ enrollmentPredefinedFilter = {} }) => enrollmentPredefinedFilter
)
